var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplodingHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1031 139.354C8.69859 133.988 8.6986 115.012 22.1031 109.646L25.1578 108.423C34.4896 104.687 38.1056 93.3731 32.6702 84.9175L31.4951 83.0895C23.9099 71.2897 34.1002 56.1357 47.8896 58.7093L57.0773 60.424C66.1578 62.1188 74.7829 55.7938 75.8961 46.6239L76.7806 39.3383C78.3813 26.1537 94.4208 20.5468 103.887 29.8628L112.277 38.1199C118.504 44.2483 128.496 44.2483 134.723 38.1199L143.113 29.8628C152.579 20.5468 168.619 26.1536 170.219 39.3383L171.104 46.6239C172.217 55.7938 180.842 62.1188 189.923 60.424L199.11 58.7092C212.9 56.1357 223.09 71.2897 215.505 83.0895L214.33 84.9175C208.894 93.3731 212.51 104.687 221.842 108.423L224.897 109.646C238.301 115.012 238.301 133.988 224.897 139.354L221.842 140.577C212.51 144.313 208.894 155.627 214.33 164.082L215.505 165.911C223.09 177.71 212.9 192.864 199.11 190.291L189.923 188.576C180.842 186.881 172.217 193.206 171.104 202.376L170.219 209.662C168.619 222.846 152.579 228.453 143.113 219.137L134.723 210.88C128.496 204.752 118.504 204.752 112.277 210.88L103.887 219.137C94.4208 228.453 78.3813 222.846 76.7806 209.662L75.8961 202.376C74.7829 193.206 66.1578 186.881 57.0773 188.576L47.8896 190.291C34.1002 192.864 23.9099 177.71 31.4951 165.911L32.6702 164.082C38.1056 155.627 34.4896 144.313 25.1578 140.577L22.1031 139.354Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1031 139.354C8.69859 133.988 8.6986 115.012 22.1031 109.646L25.1578 108.423C34.4896 104.687 38.1056 93.3731 32.6702 84.9175L31.4951 83.0895C23.9099 71.2897 34.1002 56.1357 47.8896 58.7093L57.0773 60.424C66.1578 62.1188 74.7829 55.7938 75.8961 46.6239L76.7806 39.3383C78.3813 26.1537 94.4208 20.5468 103.887 29.8628L112.277 38.1199C118.504 44.2483 128.496 44.2483 134.723 38.1199L143.113 29.8628C152.579 20.5468 168.619 26.1536 170.219 39.3383L171.104 46.6239C172.217 55.7938 180.842 62.1188 189.923 60.424L199.11 58.7092C212.9 56.1357 223.09 71.2897 215.505 83.0895L214.33 84.9175C208.894 93.3731 212.51 104.687 221.842 108.423L224.897 109.646C238.301 115.012 238.301 133.988 224.897 139.354L221.842 140.577C212.51 144.313 208.894 155.627 214.33 164.082L215.505 165.911C223.09 177.71 212.9 192.864 199.11 190.291L189.923 188.576C180.842 186.881 172.217 193.206 171.104 202.376L170.219 209.662C168.619 222.846 152.579 228.453 143.113 219.137L134.723 210.88C128.496 204.752 118.504 204.752 112.277 210.88L103.887 219.137C94.4208 228.453 78.3813 222.846 76.7806 209.662L75.8961 202.376C74.7829 193.206 66.1578 186.881 57.0773 188.576L47.8896 190.291C34.1002 192.864 23.9099 177.71 31.4951 165.911L32.6702 164.082C38.1056 155.627 34.4896 144.313 25.1578 140.577L22.1031 139.354Z",
    fill: "url(#paint0_radial_397_3183)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_397_3183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 39,
    width: 78,
    height: 153,
    fill: "url(#paint1_linear_397_3183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_397_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123 246H127C192.722 246 246 192.722 246 127V121C246 108.85 236.15 99 224 99H22C9.84974 99 0 108.85 0 121V123C0 190.931 55.069 246 123 246Z",
    fill: "url(#paint2_radial_397_3183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_397_3183)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_397_3183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 141.5,
    r: 35.5,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_397_3183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.617,
    y: 122.617,
    width: 37.7471,
    height: 37.7471,
    rx: 18.8736,
    fill: "#2C2F36"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_397_3183)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_397_3183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 141.5,
    r: 35.5,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_397_3183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.617,
    y: 122.617,
    width: 37.7471,
    height: 37.7471,
    rx: 18.8736,
    fill: "#2C2F36"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_diiii_397_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 222.5C165 211.494 160.628 200.938 152.845 193.155C145.062 185.372 134.506 181 123.5 181C112.494 181 101.938 185.372 94.1551 193.155C86.3723 200.938 82 211.494 82 222.5L123.5 222.5H165Z",
    fill: "url(#paint3_linear_397_3183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_iii_397_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 49C41 32.4315 58.8936 19 80.9664 19C84.6199 19 88.159 19.368 91.5213 20.0573C97.0805 8.37545 112.16 0 129.891 0C142.788 0 154.283 4.43182 161.731 11.3443C186.183 13.7588 205 28.5785 205 46.5C205 64.802 185.375 79.8691 160.166 81.7926L159.9 82H154.697H121.622H74C55.7746 82 41 67.2254 41 49Z",
    fill: "url(#paint4_linear_397_3183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_iii_397_3183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 74.5,
    r: 15.5,
    fill: "url(#paint5_radial_397_3183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_iii_397_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.056 13.8923C187.517 8.52351 193.618 5.6674 198.037 8.75134L214.371 20.1509C218.789 23.2348 218.213 29.9459 213.333 32.2307L195.293 40.6766C190.413 42.9615 184.889 39.1066 185.351 33.7378L187.056 13.8923Z",
    fill: "url(#paint6_radial_397_3183)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_397_3183",
    x: 84,
    y: 36.9254,
    width: 80.0359,
    height: 158.187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.07462
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.72907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.31125 0 0 0 0 0.440775 0 0 0 0 0.9 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.03585,
    dy: 3.11192
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75033
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.171094 0 0 0 0 0.615938 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3183",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.99
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_397_3183",
    x: -11,
    y: 81,
    width: 278,
    height: 181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3183",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_397_3183",
    x: 30.6489,
    y: 94.6702,
    width: 99.7021,
    height: 99.7021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.02128
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.17553
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_397_3183",
    x: 45,
    y: 102.45,
    width: 71,
    height: 74.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.55
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_397_3183",
    x: 61.617,
    y: 122.617,
    width: 37.7471,
    height: 37.7471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 31.2004,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.8523,
    dy: -32.5569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2088
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_397_3183",
    x: 116.649,
    y: 94.6702,
    width: 99.7021,
    height: 99.7021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.02128
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.17553
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_397_3183",
    x: 131,
    y: 102.45,
    width: 71,
    height: 74.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.55
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_397_3183",
    x: 147.617,
    y: 122.617,
    width: 37.7471,
    height: 37.7471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 31.2004,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.8523,
    dy: -32.5569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2088
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_diiii_397_3183",
    x: 48.6667,
    y: 153.667,
    width: 149.667,
    height: 108.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0298758 0 0 0 0 0.0216858 0 0 0 0 0.0308333 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3183",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17328 0 0 0 0 0.125777 0 0 0 0 0.178833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119503 0 0 0 0 0.086743 0 0 0 0 0.123333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_397_3183",
    result: "effect4_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect5_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -31
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_397_3183",
    result: "effect5_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_iii_397_3183",
    x: 41,
    y: -3.82353,
    width: 167.752,
    height: 91.5588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.82353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.87271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.31125 0 0 0 0 0.440775 0 0 0 0 0.9 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.75209,
    dy: 5.73529
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75488
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9125 0 0 0 0 0.171094 0 0 0 0 0.615938 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3183",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.5686
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.96363
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_iii_397_3183",
    x: 30.4319,
    y: 49,
    width: 47.7044,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.1363,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06249
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.56814,
    dy: -3.34089
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.23859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3183",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06249
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.112222 0 0 0 0 0.112222 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_iii_397_3183",
    x: 179.756,
    y: -2.51733,
    width: 48.7456,
    height: 43.8652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.1363,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06249
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.56814,
    dy: -3.34089
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.23859
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3183",
    result: "effect2_innerShadow_397_3183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06249
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.841667 0 0 0 0 0.593655 0 0 0 0 0.112222 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3183",
    result: "effect3_innerShadow_397_3183"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_397_3183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.01626 138.557) rotate(-3.10681) scale(259.365 231.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF290C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_397_3183",
    x1: 103.033,
    y1: 69.6,
    x2: 103.033,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_397_3183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109 108.561) rotate(84.1837) scale(138.15 229.664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_397_3183",
    x1: 123.5,
    y1: 181,
    x2: 123.5,
    y2: 264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1F2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_397_3183",
    x1: 84.7184,
    y1: 15.5686,
    x2: 84.7184,
    y2: 81.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_397_3183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51 62) rotate(88.977) scale(28.0045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ADBD1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_397_3183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.407 17.4066) rotate(69.7077) scale(32.6186 32.6186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF03B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_3183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplodingHead);
export default __webpack_public_path__ + "static/media/exploding-head.054944dc334c535a797595321c871b0c.svg";
export { ForwardRef as ReactComponent };